import { Icon } from '@/components/Icon';

interface ErrorScreenProps {
  title: string;
  body: string;
  onRetry?: () => void;
  cta?: { label: string; onClick: () => void };
}

export function ErrorScreen({ title, body, onRetry, cta }: ErrorScreenProps) {
  return (
    <div
      style={{
        height: '100%',
        padding: '24px 22px',
        display: 'flex',
        flexDirection: 'column',
        gap: 18,
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 16,
          background: 'var(--paper-2)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name="info" size={22} stroke="var(--ink-2)" sw={1.6} />
      </div>
      <h1
        style={{
          fontFamily: "'Instrument Serif', serif",
          fontSize: 32,
          lineHeight: 1,
          color: 'var(--ink)',
          letterSpacing: '-0.015em',
          margin: 0,
        }}
      >
        {title}
      </h1>
      <p style={{ fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.55, margin: 0 }}>{body}</p>
      <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
        {cta && (
          <button onClick={cta.onClick} className="btn btn-moss" style={{ flex: 1 }}>
            {cta.label}
          </button>
        )}
        {onRetry && (
          <button onClick={onRetry} className="btn btn-ghost" style={{ flex: cta ? 0 : 1 }}>
            повторить
          </button>
        )}
      </div>
    </div>
  );
}
